import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProjectHero = ({ project, onViewDetails }) => {
  return (
    <div className="relative bg-gradient-to-br from-primary via-secondary to-accent rounded-2xl overflow-hidden shadow-brand-lg">
      <div className="absolute inset-0 bg-black/20"></div>
      
      <div className="relative z-10 p-8 lg:p-12">
        <div className="grid lg:grid-cols-2 gap-8 items-center">
          {/* Content */}
          <div className="text-white space-y-6">
            <div className="flex items-center space-x-3">
              <span className="px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-sm font-medium">
                Featured Project
              </span>
              <span className="px-3 py-1 bg-accent/80 rounded-full text-sm font-medium">
                {project.industry}
              </span>
            </div>
            
            <h1 className="text-3xl lg:text-4xl font-bold font-heading leading-tight">
              {project.title}
            </h1>
            
            <p className="text-lg text-white/90 leading-relaxed">
              {project.description}
            </p>
            
            {/* Key Metrics */}
            <div className="grid grid-cols-2 gap-4">
              {project.keyMetrics.map((metric, index) => (
                <div key={index} className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
                  <div className="text-2xl font-bold text-accent">
                    {metric.value}
                  </div>
                  <div className="text-sm text-white/80">
                    {metric.label}
                  </div>
                </div>
              ))}
            </div>
            
            <div className="flex flex-wrap gap-4">
              <Button
                variant="default"
                className="bg-white text-primary hover:bg-white/90"
                iconName="ArrowRight"
                iconPosition="right"
                onClick={() => onViewDetails(project)}
              >
                View Full Case Study
              </Button>
              <Button
                variant="outline"
                className="border-white hover:bg-white/10"
                iconName="Share2"
                iconPosition="left"
              >
                Share Project
              </Button>
            </div>
          </div>
          
          {/* Visual */}
          <div className="relative">
            <div className="aspect-video rounded-xl overflow-hidden shadow-xl">
              <Image
                src={project.heroImage}
                alt={project.title}
                className="w-full h-full object-cover"
              />
            </div>
            
            {/* Play Button Overlay */}
            <div className="absolute inset-0 flex items-center justify-center">
              <button className="w-16 h-16 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white transition-colors duration-200 group">
                <Icon 
                  name="Play" 
                  size={24} 
                  className="text-primary ml-1 group-hover:scale-110 transition-transform duration-200" 
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectHero;